var render, staticRenderFns
import script from "./BrushTool.vue?vue&type=script&lang=js&"
export * from "./BrushTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BrushTool.vue"
export default component.exports